// ======================================================================
// File Name       : enterpriseNotice
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as ActionTypes from '../constants/actionTypes/enterpriseNotice';
import * as ContentConstant from '../constants/ContentConstant';
import { RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER, DEFAULT_DATE_SHORT_FORMAT_SERVER } from '../constants/index';
import { USE_DATE_RELEASE } from '../constants/EnterpriseNoticeConstants';

const initialState = {
  noticeInfo: {
    noticeSecernId: null,
    noticeTitle: null,
    noticeContent: null,
    releaseTargetForEnterprise: 0,
    publicStatus: 1,
    publicDateFrom: '',
    publicDateTo: '',
    releasePeriod: USE_DATE_RELEASE.INDEFINITE_PERIOD,
  },
};

export default function enterpriseNotice(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.ENTERPRISE_NOTICE_EDIT: {
      const noticeInfoTemp = action.noticeInfo;
      return {
        ...state,
        noticeInfo: noticeInfoTemp,
      };
    }
    case ActionTypes.ENTERPRISE_RECEIVED_NOTICE_SECERN_ID: {
      const { noticeForEnterpriseSecernId } = action;
      return {
        ...state,
        noticeForEnterpriseSecernId,
      };
    }
    case ActionTypes.ENTERPRISE_RECEIVED_NOTICE_SECERN_DETAIL: {
      const noticeInfoList = action.res;
      let noticeInfotemp = null;
      if (noticeInfoList && noticeInfoList.length) {
        noticeInfotemp = noticeInfoList[0];
      }
      return {
        ...state,
        noticeInfo: noticeInfotemp,
      };
    }
    default: {
      return state;
    }
  }
}
